/* src/app/views/client-data/client-data.component.scss */
:host {
  --client-surface-soft: #ffffff;
  --client-border-subtle: #d9e1ec;
  --client-shadow: 0 14px 32px rgba(18, 38, 63, 0.1);
  --client-left-anchor: 40px;
  --client-content-width: 650px;
  --document-button-offset: 48px;
  --preform-action-right-inset: 32px;
}
.container {
  background: #ffffff;
  border: 1px solid var(--client-border-subtle);
  border-radius: 14px;
  box-shadow: var(--client-shadow);
  padding: 6px 0 20px;
}
.client-data-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  float: none;
  margin-bottom: 24px;
}
.client-data-header > [class*=col-] {
  flex: 0 0 100%;
  max-width: 100%;
}
.client-data-title-position {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-right: 0 !important;
}
.client-data-title {
  display: block;
  margin: 0;
  margin-bottom: 6px;
}
.client-data-subtitle {
  display: block;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  line-height: 22px;
  color: #5f5f5f;
  max-width: 940px;
}
.client-data-main-header .client-data-main-title {
  margin: 0 0 6px 0;
}
.client-data-main-header #subTitle.client-data-subtitle {
  margin: 0;
}
.check-document {
  margin-left: var(--client-left-anchor);
  width: calc(100% - var(--client-left-anchor) * 2);
}
.form-client-data {
  margin-left: var(--client-left-anchor);
  width: min(var(--client-content-width), 100% - var(--client-left-anchor));
}
.client-data-preform-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  flex: 0 0 100%;
  margin-left: 0;
  width: 100%;
  margin-top: 28px;
  gap: 8px;
  padding-top: 18px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  margin-left: var(--client-left-anchor);
  width: calc(100% - var(--client-left-anchor));
  margin-top: 28px;
  gap: 8px;
  padding-top: 18px;
  border-top: 1px solid #d9dfe9;
  box-sizing: border-box;
}
.check-document {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 16px;
  gap: 16px;
  background: var(--client-surface-soft);
  border: 1px solid #dde5f0;
  border-radius: 14px;
  padding: 18px;
  box-sizing: border-box;
}
.check-document > .documents-itens {
  flex: 1 1 0;
  min-width: 0;
  width: auto !important;
  max-width: none;
}
.check-document > .documents-itens > .filling-item {
  flex: 1 1 auto;
  width: 100% !important;
  max-width: none !important;
}
.check-document > .filling-item {
  flex: 0 0 auto;
  width: auto !important;
  max-width: none !important;
  display: flex;
  align-items: flex-start;
  padding-top: var(--document-button-offset);
}
.document-feedback-slot {
  min-height: 24px;
}
.check-document .btn-consult {
  height: 56px;
  border-radius: 12px;
}
.check-document > .client-data-preform-actions {
  flex: 0 0 100%;
  max-width: 100%;
}
.form-client-data {
  margin-top: 8px;
}
.container-form {
  margin-top: 8px;
  background: var(--client-surface-soft);
  border: 1px solid #dce4ef;
  border-radius: 16px;
  padding: 22px 0 16px;
}
.check-document .filling-item {
  margin-left: 0;
}
.client-data-header > [class*=col-],
.check-document > [class*=col-],
.form-client-data > [class*=col-],
.form-client-data [class*=col-],
.street-number > [class*=col-],
.street-number [class*=col-] {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.documents-itens,
.input-wrapper,
.input-number,
.element-add-edit {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 14px;
}
.filling-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.documents-itens {
  margin-right: 0;
}
.documents-itens-label,
.input-wrapper-label,
.input-number-label,
.element-add-edit-filter {
  display: block;
  width: 100%;
  font-size: 17px;
  line-height: 1.3;
  font-weight: 500;
  color: #1b2538;
  margin-bottom: 12px;
  text-align: left;
}
.documents-itens-input,
.input-wrapper-input,
.input-number-input {
  display: block;
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #b8c1cc;
  border-radius: 12px;
  margin-top: 0;
  padding-left: 18px;
  padding-right: 18px;
  font-size: 16px;
  color: #4b5563;
  line-height: 1.25;
  box-sizing: border-box;
}
.documents-itens-input:focus,
.input-wrapper-input:focus,
.input-number-input:focus {
  outline: none;
  border-color: #8ea6c9;
  box-shadow: 0 0 0 3px rgba(142, 166, 201, 0.18);
}
.field-limit-hint {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  line-height: 16px;
  color: #7a8595;
}
#customerDateOfBirth {
  padding-left: 15px !important;
}
.street-number {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  margin-left: 0;
  box-sizing: border-box;
}
.street-number .address-field {
  flex: 1 1 auto;
  min-width: 0;
}
.street-number .number-field {
  flex: 0 0 190px;
  max-width: 190px;
}
::placeholder {
  color: #9aa4b2;
  font-size: 15px;
}
.element-add-edit {
  align-items: stretch;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-add-edit p-dropdown {
  width: 100%;
}
:host ::ng-deep .element-add-edit .ui-dropdown,
:host ::ng-deep .element-add-edit .p-dropdown {
  width: 100% !important;
  min-height: 56px;
  height: auto;
  border: 1px solid #b8c1cc;
  border-radius: 12px;
  background: #ffffff;
}
:host ::ng-deep .element-add-edit .ui-dropdown .ui-dropdown-label,
:host ::ng-deep .element-add-edit .p-dropdown .p-dropdown-label {
  padding: 16px 44px 16px 18px;
  font-size: 15px;
  color: #4b5563;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
  overflow: visible;
}
:host ::ng-deep .element-add-edit .ui-dropdown .ui-dropdown-trigger,
:host ::ng-deep .element-add-edit .p-dropdown .p-dropdown-trigger {
  width: 40px;
  color: #6b7280;
}
:host ::ng-deep .element-add-edit .ui-dropdown:not(.ui-state-disabled).ui-state-focus,
:host ::ng-deep .element-add-edit .p-dropdown:not(.p-disabled).p-focus {
  border-color: #8ea6c9;
  box-shadow: 0 0 0 3px rgba(142, 166, 201, 0.18);
}
:host ::ng-deep .p-dropdown-panel {
  max-width: min(650px, 100vw - 24px);
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-items {
  max-height: 280px;
}
:host ::ng-deep .p-dropdown-panel .p-dropdown-item,
:host ::ng-deep .p-dropdown-panel .p-dropdown-empty-message {
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
}
.client-data-message {
  display: block;
  margin-top: 6px;
  margin-bottom: 4px;
  width: 100%;
}
.zip-lookup-feedback {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef5ff;
  color: #22518a;
  font-size: 13px;
  line-height: 1.2;
}
.zip-lookup-feedback .pi {
  font-size: 14px;
}
.documents-itens .client-data-message,
.input-wrapper .client-data-message,
.street-number .client-data-message,
.element-add-edit .client-data-message {
  max-width: 100%;
}
.container-form {
  display: flex;
  flex-direction: column;
  margin-left: var(--client-left-anchor);
  width: calc(100% - var(--client-left-anchor) * 2);
  margin-bottom: 48px;
  box-sizing: border-box;
}
form {
  border: none !important;
  box-shadow: none !important;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 60px;
  font-weight: bold;
}
.btn-consult,
.btn-return {
  width: 137px;
  height: 50px;
  border-radius: 12px;
  margin-top: 0;
  margin-right: 0;
}
.btn-consult {
  background: #046cea;
  border: 1px solid #046cea;
}
.btn-consult-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-return {
  background: #ffffff;
  border: 1px solid #046cea;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-consult:hover:not(:disabled),
.btn-return:hover:not(:disabled) {
  background: #044ea7;
}
.btn-consult:disabled,
.btn-return:disabled {
  background: #e5e5e5;
  border-color: #aaaaaa;
  cursor: not-allowed;
  opacity: 0.7;
}
.btn-consult:disabled .btn-consult-label,
.btn-return:disabled .btn-return-label,
.btn-consult:disabled .pi,
.btn-return:disabled .pi {
  color: #202020;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
.button-position .btn-return,
.button-position .btn-consult {
  margin-top: 0 !important;
  margin-right: 0 !important;
}
.client-data-preform-actions .btn-return {
  margin-top: 0 !important;
  margin-right: 0 !important;
}
@media only screen and (max-width: 900px) {
  .documents-itens-label,
  .input-wrapper-label,
  .input-number-label,
  .element-add-edit-filter {
    font-size: 16px;
  }
  .documents-itens-input,
  .input-wrapper-input,
  .input-number-input {
    height: 52px;
    font-size: 16px;
  }
  :host ::ng-deep .element-add-edit .ui-dropdown,
  :host ::ng-deep .element-add-edit .p-dropdown {
    min-height: 52px;
  }
  :host ::ng-deep .element-add-edit .ui-dropdown .ui-dropdown-label,
  :host ::ng-deep .element-add-edit .p-dropdown .p-dropdown-label {
    font-size: 16px;
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .client-data-subtitle {
    font-size: 14px;
  }
  .form-client-data,
  .button-position {
    margin-left: 20px;
    width: calc(100% - 20px);
  }
  .check-document {
    margin-left: 20px;
    width: calc(100% - 40px);
  }
  .form-client-data {
    margin-left: 20px;
    width: calc(100% - 20px);
  }
  .check-document {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 10px;
    margin-top: 14px;
    padding: 14px;
  }
  .check-document > .filling-item {
    padding-top: 0;
  }
  .check-document > .documents-itens,
  .check-document > .filling-item,
  .check-document .documents-itens > .filling-item {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
  .form-client-data {
    margin-top: 14px;
  }
  .container-form {
    margin-left: 20px;
    width: calc(100% - 40px);
    border-radius: 12px;
    padding: 16px 0 10px;
  }
  .button-position,
  .client-data-preform-actions {
    justify-content: flex-start;
  }
  .btn-consult,
  .btn-return {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
  .street-number {
    flex-wrap: wrap;
  }
  .street-number .address-field,
  .street-number .number-field {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .documents-itens,
  .input-wrapper,
  .input-number,
  .element-add-edit {
    margin-bottom: 12px;
  }
  .documents-itens-label,
  .input-wrapper-label,
  .input-number-label,
  .element-add-edit-filter {
    font-size: 15px;
    margin-bottom: 9px;
  }
  .documents-itens-input,
  .input-wrapper-input,
  .input-number-input {
    height: 48px;
    font-size: 15px;
    padding-left: 14px;
    padding-right: 14px;
    border-radius: 10px;
  }
  :host ::ng-deep .element-add-edit .ui-dropdown,
  :host ::ng-deep .element-add-edit .p-dropdown {
    min-height: 48px;
    border-radius: 10px;
  }
  :host ::ng-deep .element-add-edit .ui-dropdown .ui-dropdown-label,
  :host ::ng-deep .element-add-edit .p-dropdown .p-dropdown-label {
    font-size: 15px;
    padding: 12px 40px 12px 14px;
  }
  .client-data-header {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 24px;
  }
  .client-data-title {
    margin-bottom: 8px;
  }
  .client-data-subtitle {
    font-size: 12px;
  }
  .form-client-data,
  .button-position {
    margin-left: 8px;
    width: calc(100% - 8px);
    margin-top: 12px;
  }
  .check-document {
    margin-left: 8px;
    width: calc(100% - 16px);
    margin-top: 12px;
  }
  .client-data-preform-actions {
    margin-top: 12px;
  }
  .container-form {
    margin-left: 8px;
    width: calc(100% - 16px);
  }
  .form-client-data {
    margin-left: 8px;
    width: calc(100% - 8px);
    margin-top: 12px;
  }
  .check-document {
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 10px;
    padding: 12px;
    border-radius: 12px;
  }
  .check-document > .documents-itens,
  .check-document > .filling-item {
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
  }
  .button-position,
  .client-data-preform-actions {
    justify-content: flex-end;
  }
  .btn-consult,
  .btn-return {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    margin-top: 10px !important;
  }
}
@media only screen and (max-width: 400px) {
  .btn-consult,
  .btn-return {
    width: 100%;
    min-width: 80px;
    max-width: 100%;
  }
}
/*# sourceMappingURL=client-data.component-BEEIXKW2.css.map */
